/*This controller function will perform diffrent operations like Closing Pop,
    Processing multipart files in formData, and processing an ajax request*/

(function () {

    'use strict';

    var StatementOfAccountCtrl = function ($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel, $http) {
        var _this = this;

        console.log('StatementOfAccountCtrl init!');
        if (!angular.isDefined(passedModel)) {
            passedModel = {};
        }
        $scope.ngModel = passedModel;

        /*This method will close popup*/
        $scope.ok = function () {
            $uibModalInstance.close(this.ngModel);
        };

        /*This method will close popup*/
        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        /*This method will get all the files and append to the form data
        as these files to be processed and needs to sent as email attachment*/
        $scope.handleFiles = function (propertyKey, $files) {
            angular.forEach($files, function (value, key) {
                formdata.append(propertyKey, value);
            });
        };

        /*This method will process the data to function and willsend email with query details*/
        $scope.sendQueriedDetails = function ($event) {
            var isTrue = false;
            for (var key in $scope.ngModel.queryTypeId)  {
                if(isTrue == false) {
                    isTrue = $scope.ngModel.queryTypeId[key];
                } else {
                    break;
                }
            }

            if(isTrue) {
                var ajaxUrl = WEBAPP_PATH + "/invoiceViewer/sendPayrollDetailsEmail";

                var queryTypeList = new Array();
                angular.forEach($scope.ngModel.queryTypeId, function (value, key) {
                    if (value == true) {
                        queryTypeList.push(key)
                    }
                });
                $scope.ngModel.selectedQueryIds = queryTypeList;

                ajaxCall.getData(ajaxUrl, $scope.ngModel, true).then(function(result) {
                    if (result.data.success == true) {
                        xmsNotificationFactory.bulk(result.data.response.message, result.data.response.type);
                        $scope.cancel();
                    }
                }, function(result) {
                    xmsNotificationFactory.bulk("Error: Unable to execute query fuilfillment", "danger");
                    $scope.cancel();
                });
            }
            return false;
        };

        $scope.sendResolveRemarks = function ($event) {

            var ajaxUrl = WEBAPP_PATH + "/invoiceViewer/resolveWithRemarks";
            var ajaxData = $('#resolvePopupForm').serializeArray();
            var formdata = new FormData();
            $.each(ajaxData, function (key, input) {
                formdata.append(input.name, input.value);

            });

            var request = {
                method: 'POST',
                url: ajaxUrl,
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            };

            $http(request).then(function (result) {
                if (result.data.response.type == "success") {
                    xmsNotificationFactory.bulk(result.data.response.message, result.data.response.type);
                    $scope.cancel($event);
                }
            },function (result) {
                if (result.data.response.type == "error") {
                    xmsNotificationFactory.bulk(result.data.response.message, result.data.response.type);
                    $scope.cancel($event);
                }
            });
            return false;
        };
    };
    StatementOfAccountCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params', '$http'];
    angular.module('app').controller('StatementOfAccountCtrl', StatementOfAccountCtrl);

}());